<ng-template #content_plan_purchase_edit let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.common && localService.languageContent.plan_purchase">
        <div class="side_popup_header">
            <span>{{localService.languageContent.plan_purchase.plan_purchase}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
        <div class="side_popup_body" *ngIf="item" [ngStyle]="{'max-height' : localService.sideBarBodyHeight + 'px'}">
            <div class="row">
                <div class="col-md-4">
                    <app-label [Text]="localService.languageContent.plan_purchase.plan_type" />
                </div>
                <div class="col-md-8">
                    <span *ngIf="editId">
                        {{localService.getText(planTypes,item.v3)}}
                    </span>
                    <ngx-select *ngIf="!editId" style="position: relative; width: calc(100% - 150px);"
                        [(ngModel)]="item.v3" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="elligiblePlanTypeToSelect" (select)="onSetDays()" [noAutoComplete]="true">
                    </ngx-select>
                </div>
            </div>
            <div class="row" *ngIf="PlanType.BasicPlan.toString() == item.v3 && !(item.v16 == '1' || isHasNoLimit)">
                <div class="col-md-4">
                </div>
                <div class="col-md-8">
                    <span *ngIf="editId">
                        {{localService.getText(basicPlanMonths,item.v15)}}
                    </span>
                    <ngx-select *ngIf="!editId" style="position: relative; width: calc(100% - 150px);"
                        [(ngModel)]="item.v15" [optionValueField]="'key'" [optionTextField]="'value'"
                        [items]="elligibleMonthlyPlanTypeToSelect" (select)="onSetDays(true)" [noAutoComplete]="true">
                    </ngx-select>
                </div>
            </div>
            <div class="row" *ngIf="PlanType.Employee.toString() == item.v3">
                <div class="col-md-6">
                    <app-label [Text]="localService.languageContent.common.phone_number" />
                </div>
                <div class="col-md-6">
                    <span class="en">+ {{localService.getContactPrefixByCountryCode()}}</span>
                    <span class="en" *ngIf="editId">&nbsp;{{item.v17}}</span>
                    <input *ngIf="!editId" autocomplete="off" type="number" class="number"
                        [ngClass]="item.v17 ? 'en' : ''" [(ngModel)]="item.v17"
                        style="width:calc(95% - 40px);text-align:left;"
                        (keypress)="localService.isNumberOnly($event,numericConfigPhoneNumber)"
                        placeholder="*{{localService.languageContent.common.phone_number}}"
                        title="*{{localService.languageContent.common.phone_number}}" id="{{elementIds.ph_num}}" />
                </div>
            </div>
            <div class="row" *ngIf="PlanType.Employee.toString() == item.v3 && editId">
                <div class="col-4">
                    <app-label [Text]="localService.languageContent.table.name" />
                </div>
                <div class="col-8">
                    <span class="{{localService.getLanguageCode(item.v10)}}">{{item.v9}}</span>
                </div>
            </div>
            <div class="row" *ngIf="item.v16 == '1' || isHasNoLimit">
                <div class="col-12">
                    <span>{{localService.languageContent.plan_purchase.no_limit}}</span>
                </div>
            </div>
            <div class="row" *ngIf="item.v16 != '1' && !isHasNoLimit">
                <div class="col-6">
                    <app-label
                        [Text]="BasicPlanMonths.Custom.toString() == item.v15 ? localService.languageContent.plan_purchase.cost_per_day : localService.languageContent.plan_purchase.cost_per_month" />
                </div>
                <div class="col-6">
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v14 ? 'en' : ''"
                        [(ngModel)]="item.v14" style="width:calc(95% - 30px);"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="*{{BasicPlanMonths.Custom.toString() == item.v15 ? localService.languageContent.plan_purchase.cost_per_day : localService.languageContent.plan_purchase.cost_per_month}}"
                        title="*{{BasicPlanMonths.Custom.toString() == item.v15 ? localService.languageContent.plan_purchase.cost_per_day : localService.languageContent.plan_purchase.cost_per_month}}"
                        id="{{elementIds.txt_amount}}"
                        *ngIf="canEditByB2b || (!editId && (interactionType == InteractionType.Bill_PnixSoft || BasicPlanMonths.Custom.toString() == item.v15))"
                        (blur)="onSetAmount()" />
                    <span class="en"
                        *ngIf="!(canEditByB2b || (!editId && (interactionType == InteractionType.Bill_PnixSoft || BasicPlanMonths.Custom.toString() == item.v15)))"
                        [innerHTML]="localService.getCurencyCode() + ' ' + (item.v14 | number:'1.2-2')">
                    </span>
                </div>
            </div>
            <div class="row" *ngIf="item.v16 != '1' && !isHasNoLimit">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.days" />
                </div>
                <div class="col-6">
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v2 ? 'en' : ''"
                        [(ngModel)]="item.v2" style="width:calc(95% - 30px);"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="*{{localService.languageContent.plan_purchase.days}}"
                        title="*{{localService.languageContent.plan_purchase.days}}" id="{{elementIds.txt_days}}"
                        *ngIf="!editId && BasicPlanMonths.Custom.toString() == item.v15" (blur)="onSetAmount()" />
                    <span class="en" *ngIf="!editId && BasicPlanMonths.Custom.toString() != item.v15">{{totalMonths}} *
                        {{item.v3
                        == PlanType.TrailPeriod.toString() ? item.v2 :
                        daysInMonth}} = {{item.v2}}</span>
                    <span class="en" *ngIf="editId">{{item.v2}}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.amount" />
                </div>
                <div class="col-6">
                    <span class="en" *ngIf="!(!editId && isHasNoLimit)"
                        [innerHTML]="'&nbsp;' + localService.getCurencyCode() + ' ' + (item.v1 | number:'1.2-2')">
                    </span>
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v1 ? 'en' : ''"
                        [(ngModel)]="item.v1" style="width:calc(95% - 30px);"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="*{{localService.languageContent.plan_purchase.amount}}"
                        title="*{{localService.languageContent.plan_purchase.amount}}" id="{{elementIds.txt_amount}}"
                        *ngIf="!editId && isHasNoLimit" (blur)="onSetAmount(true)" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.tax" />
                </div>
                <div class="col-6">
                    <span class="en">{{item.v4 | number:'1.2-2'}}&nbsp;%</span>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.total" />
                </div>
                <div class="col-6">
                    <span class="en" style="font-weight: bold;"
                        [innerHTML]="localService.getCurencyCode() + ' ' + (item.v13 | number:'1.2-2')">
                    </span>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.qty" />
                </div>
                <div class="col-6">
                    <span class="en"
                        *ngIf="!(!editId && planInteractionType != InteractionType.Business)">{{item.v19}}</span>
                    <input autocomplete="off" type="number" class="number" [ngClass]="item.v19 ? 'en' : ''"
                        [(ngModel)]="item.v19" style="width:calc(95% - 30px);"
                        (keypress)="localService.isNumberOnly($event,numericConfig)"
                        placeholder="*{{localService.languageContent.plan_purchase.qty}}"
                        title="*{{localService.languageContent.plan_purchase.qty}}" id="{{elementIds.txt_amount}}"
                        *ngIf="!editId && planInteractionType != InteractionType.Business" (blur)="onSetAmount()" />
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <app-label [Text]="localService.languageContent.plan_purchase.grand_total" />
                </div>
                <div class="col-6">
                    <span class="en" style="font-weight: bold;"
                        [innerHTML]="localService.getCurencyCode() + ' ' + (onGetGrandTotal()  | number:'1.2-2')">
                    </span>
                </div>
            </div>
            <div class="row" *ngIf="interactionType == InteractionType.Bill_PnixSoft && !editId">
                <div class="col-12">
                    <label style="margin-left: 10px;">
                        <input type="checkbox" [(ngModel)]="isHasNoLimit" (change)="onSetAmount(isHasNoLimit)">
                        <span
                            style="font-size:16px;color:darkslategrey">&nbsp;{{localService.languageContent.plan_purchase.no_limit}}</span>
                    </label>
                </div>
            </div>
        </div>
        <div class="side_popup_footer" *ngIf="!editId || canEditByB2b">
            <div class="row" *ngIf="renewalValidity.length >= 5">
                <div class="col-12" style="text-align: left;">
                    <div>
                        {{localService.languageContent.plan_purchase.renew_days_min}}
                        <span class="en">&nbsp;:&nbsp;{{renewalValidity[0]}}</span>
                    </div>
                    <div>
                        {{localService.languageContent.plan_purchase.available_valid_days}}
                        <span class="en">&nbsp;:&nbsp;{{renewalValidity[1]}}&nbsp;({{renewalValidity[2]}})</span>
                    </div>
                    <div>
                        {{localService.languageContent.plan_purchase.min_days_to_wait}}
                        <span class="en">&nbsp;:&nbsp;{{renewalValidity[3]}}&nbsp;({{renewalValidity[4]}})</span>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <button type="button" class="btn btn-primary"
                        (click)="onAction(1)">{{localService.languageContent.common.save}}</button>
                </div>
            </div>
        </div>
    </div>
</ng-template>